// extracted by mini-css-extract-plugin
module.exports = {"default":"Card_default__1FxKC","row-label":"Card_row-label__2KCfm","no-content":"Card_no-content__2o_VD","defaultInfo":"Card_defaultInfo__FEcjT"};